module.exports = new __parcel__URL__("7557-3.74e36fa4.png").toString();